export default "<pagination-controls\n  previousLabel=\"\"\n  nextLabel=\"\"\n  (pageChange)=\"page($event)\"\n></pagination-controls>\n"